module.exports = __webpack_public_path__ + "img/icon_event_bonus.0960ad7d.png";